import { FilterMultiSelectProps } from 'components/shared/filters/FilterMultiSelect';
import {
  ADDITIONAL_FILTERS,
  CASE_MANAGER_DROPDOWN,
  COMANAGEMENT_TEAM,
  createClientDropdown,
  createGroupTypesDropdowns,
  DISCHARGE_REASON_DROPDOWN,
  EPISODE_TYPE_DROPDOWN,
  getComanagementTeamManagerFilterDropdowns,
  PLAN_TYPE_DROPDOWN,
  sortFilterDropdowns,
  UTILIZATION_MANAGER_DROPDOWN,
} from 'constants/filterConfigs';
import { OWNER_CLIENT } from 'constants/filterKeysConstants';
import Profile from 'models/Profile';

export const getFilterSections = (profile: Profile) => {
  // Case Manager and Utilization Manager filters should be shown if the client
  // has them enabled on any one of their enabled group types.
  const caseManagerEnabled = !!profile.actingClient?.clientGroupTypes.some(
    (clientGroupType) => clientGroupType.config.caseManager
  );
  const utilizationManagerEnabled = !!profile.actingClient?.clientGroupTypes.some(
    (clientGroupType) => clientGroupType.config.utilizationManager
  );

  const additionalFilterDropdowns: FilterMultiSelectProps[] = [
    ...(caseManagerEnabled ? [CASE_MANAGER_DROPDOWN] : []),
    DISCHARGE_REASON_DROPDOWN,
    EPISODE_TYPE_DROPDOWN,
    PLAN_TYPE_DROPDOWN,
    ...(utilizationManagerEnabled ? [UTILIZATION_MANAGER_DROPDOWN] : []),
  ];

  return [
    {
      title: COMANAGEMENT_TEAM,
      filters: sortFilterDropdowns([
        ...(profile.canActAsProvider
          ? [createClientDropdown([], 'Organization', OWNER_CLIENT, { groupTypeType: 'manager' })]
          : []),
        ...createGroupTypesDropdowns(profile.enabledProviderTypes ?? []),
        ...getComanagementTeamManagerFilterDropdowns(profile),
      ]),
    },
    {
      title: ADDITIONAL_FILTERS,
      filters: additionalFilterDropdowns,
    },
  ];
};
